import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRoutePackingBoxService } from '../../../api/elite/routes/packing-box.service';
import { PackingBoxDto } from '../../../api/elite/dto/packing-box.dto';

@Injectable({
  providedIn: 'root',
})
export class PackingBoxTableZebraApiService {
  private readonly apiPackingBoxRouter = inject(ApiRoutePackingBoxService);

  constructor() {}

  createPackingBox(
    body: PackingBoxDto['createTraceability']['body']
  ): Observable<number[]> {
    return this.apiPackingBoxRouter.createTraceabilityPackingBox(body);
  }

  deletePackingBox(id: number | number[]): Observable<any> {
    return this.apiPackingBoxRouter.deleteTraceabilityPackingBox(id);
  }
}
